/* istanbul ignore file */
import HttpService from "@/services/httpService.js";

export default {
  install(app) {
    app.config.globalProperties.$http = HttpService;
    app.provide("http", HttpService);
  },
};
